<div class="confirm-dialog" [attr.data-tone]="tone">
  <button type="button" class="confirm-dialog__close" (click)="close()" aria-label="Close">
    <i class="fa-solid fa-xmark"></i>
  </button>

  <div class="confirm-dialog__body">
    <div class="confirm-dialog__icon" aria-hidden="true">
      <i [class]="iconClass"></i>
    </div>

    <h2 class="confirm-dialog__title">{{ title }}</h2>
    <p class="confirm-dialog__message">{{ message }}</p>

    @if (entityLabel) {
      <p class="confirm-dialog__entity">{{ entityLabel }}</p>
    }

    @if (toggle) {
      <div class="confirm-dialog__toggle" [class.confirm-dialog__toggle--on]="toggled()">
        <span class="confirm-dialog__toggle-text">
          <span class="confirm-dialog__toggle-label" id="confirm-dialog-toggle-label">{{ toggle.label }}</span>
          @if (toggle.description) {
            <span class="confirm-dialog__toggle-description" id="confirm-dialog-toggle-description">{{ toggle.description }}</span>
          }
        </span>
        <input
          type="checkbox"
          role="switch"
          class="confirm-dialog__switch"
          aria-labelledby="confirm-dialog-toggle-label"
          [attr.aria-describedby]="toggle.description ? 'confirm-dialog-toggle-description' : null"
          [checked]="toggled()"
          [attr.aria-checked]="toggled()"
          (change)="toggled.set($any($event.target).checked)"
        />
      </div>
    }
  </div>

  <div class="confirm-dialog__footer">
    <button type="button" class="confirm-dialog__btn confirm-dialog__btn--cancel" (click)="close()">
      {{ cancelText }}
    </button>
    <button type="button" class="confirm-dialog__btn confirm-dialog__btn--confirm" (click)="confirm()">
      {{ confirmText }}
    </button>
  </div>
</div>
